var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkLastBillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M31.083 5.33984C29.555 5.33984 28.3325 6.57927 28.3325 8.09034V9.73724H33.8335V8.09034C33.8335 6.57927 32.6111 5.33984 31.083 5.33984Z",
    fill: "url(#paint0_linear_3314_1994)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M23.3743 33.499L23.0218 33.1464L23.0218 33.1464L23.0141 33.1389L21.8087 31.9674L21.2784 31.4521L20.7556 31.9749L19.8767 32.8539L19.8728 32.8578L19.2525 33.4689L18.896 33.1125L18.896 33.1125L18.8921 33.1086L17.7206 31.9541L17.1903 31.4315L16.6638 31.9579L15.785 32.8368L15.781 32.8408L15.1948 33.4181L14.8382 33.0615L14.8382 33.0615L14.8294 33.0529L13.7767 32.0342L13.2466 31.5211L12.7249 32.0428L11.8445 32.9232L11.4433 33.3171L11.086 32.9597L11.086 32.9596L11.0772 32.951L10.0245 31.9323L9.49434 31.4193L8.97263 31.941L8.24951 32.6641V9.0477C8.28028 7.38307 9.57882 6.08984 11.065 6.08984H25.5465C25.159 6.66122 24.9334 7.35359 24.9334 8.09034V31.9399L24.8304 32.0428L23.9476 32.9257L23.3743 33.499Z",
    fill: "url(#paint1_linear_3314_1994)",
    stroke: "url(#paint2_linear_3314_1994)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M8.28271 9.04113C8.28271 7.71752 9.16486 6.59257 10.3586 6.22042C9.72658 6.98922 9.34645 7.97222 9.34645 9.04113V31.7115L9.10082 31.948L8.28271 32.7358V9.04113Z",
    fill: "url(#paint3_linear_3314_1994)",
    stroke: "url(#paint4_linear_3314_1994)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.83 11.3671H15.3088M12.83 15.6457H22.9151M12.83 19.9073H22.9151M12.83 24.1859H22.9151M19.893 27.5306H22.9152M31.0817 5.33984H11.234C9.1966 5.33984 7.53271 7.00372 7.53271 9.04113V34.4578L9.62106 32.4883L11.6245 34.3899L13.5261 32.5901L15.5295 34.4917L17.6179 32.5222L19.7572 34.5427L21.8794 32.5392L24.0527 34.5766L26.141 32.6071L28.3143 34.6615V8.09034C28.3143 6.56229 29.5537 5.33984 31.0648 5.33984C32.5928 5.33984 33.8153 6.57927 33.8153 8.09034V9.73724H28.2973",
    stroke: "url(#paint5_linear_3314_1994)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3314_1994",
    x1: 28.3325,
    y1: 7.89698,
    x2: 33.5095,
    y2: 5.78293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3314_1994",
    x1: 7.49951,
    y1: 22.3315,
    x2: 29.1989,
    y2: 17.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3314_1994",
    x1: 7.49951,
    y1: 22.3315,
    x2: 29.1989,
    y2: 17.2813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3314_1994",
    x1: 7.53271,
    y1: 22.2821,
    x2: 14.3782,
    y2: 21.8016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3314_1994",
    x1: 7.53271,
    y1: 22.2821,
    x2: 14.3782,
    y2: 21.8016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3314_1994",
    x1: 7.53272,
    y1: 22.3907,
    x2: 34.1159,
    y2: 14.6125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLastBillIcon);
export default __webpack_public_path__ + "static/media/darkLastBillIcon.82bf876c540d373b9fd9bfec230c310b.svg";
export { ForwardRef as ReactComponent };